// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserLabel_avatar__cPP0r"};